import React, { FC, FunctionComponent, SVGProps } from 'react'
import "./button.scss"

interface ButtonProps {
    text?: string
    onClick: () => void
    Icon?: FunctionComponent<SVGProps<SVGSVGElement>>
    extraStyles?: React.CSSProperties
    disabled?: boolean
}
const Button: FC<ButtonProps> = ({ extraStyles, Icon, onClick, text, disabled }) => {
    const handleClick = () => {
        if (!disabled) {
            onClick();
        }
    };
    return (
        <div
            style={extraStyles}
            onClick={handleClick}
            className={`button-main-container ${disabled ? "disabled" : ""}`} 
        >
            {Icon && <Icon />}
            <span className="button-text">{text}</span>
        </div>
    );
}

export default Button